import React, { useMemo, Fragment, useEffect, useState, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { MaterialReactTable } from 'material-react-table';
import { useOutletContext } from "react-router-dom";

const MpgProgrammeDescriptorDialog = ({ open, setOpen, PDListFromAPI, addedPDData, setAddedPDData }) => {

    /** get only active standard resources only for selection and display*/
    const listOfOnlyActiveStandardTypeResources = !!PDListFromAPI && PDListFromAPI.filter((eachItem) => {
        if (eachItem?.ProgramDescripitorType === "Standard" && !!eachItem?.IsActive) {
            return eachItem
        }
    })

    const tableInstanceRef = useRef(null);

    const resourcesCMSData = useOutletContext();

    const fetchClientAccResDtlsLabel = (key) => {
      if (resourcesCMSData && resourcesCMSData?.pageContent["ClientAccountResourcesDetails"]) {
        const resourcesCMSDataLabel = resourcesCMSData.pageContent["ClientAccountResourcesDetails"];
        return returnLabel(resourcesCMSDataLabel?.Labels, key)
      }
    }
    
    const fetchMngResRepoListLabel = (key) => {
        //console.log(resourcesCMSDataLabel);
        if (resourcesCMSData && resourcesCMSData?.pageContent["ManageResourceRepoList"]) {
            const resourcesCMSDataLabel = resourcesCMSData.pageContent["ManageResourceRepoList"];
            return returnLabel(resourcesCMSDataLabel?.Labels, key)
        }
        return '';
    }
  
    const fetchCommonCMSLabel = (key) => {
      if (resourcesCMSData && resourcesCMSData?.pageContent["CommonComponent"]) {
          const commonCMSDataLabel = resourcesCMSData.pageContent["CommonComponent"];
          return returnLabel(commonCMSDataLabel?.Labels, key)
      }
      return '';
    }
  
    const returnLabel = (labelArray, key) => {
      if (labelArray.length > 0 && key) {
          return labelArray.find((x) => x.Key === key)?.Phrase || '';
      }
      return '';
    }

    const columns = useMemo(
        () => [
            {
                accessorKey: "ProgramDescripitorTitle",
                id: 'ProgramDescripitorTitle',
                header: fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ResourceTitle'), //"Resource Title",
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: 
                { placeholder: fetchMngResRepoListLabel ("ManageResourceRepoList.PlaceholderResourceTitle") }
            },
            {
                accessorKey: "ProgramDescripitorFileName",
                header: fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ResourceFileName'), //"Resource File Name",
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: 
                { placeholder: fetchMngResRepoListLabel ("ManageResourceRepoList.PlaceholderResourceFileName") }
            },
            {
                accessorKey: "ProgramDescripitorType",
                header: fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ResourceType'), //"Resource Type",
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: 
                { placeholder: fetchClientAccResDtlsLabel ("ClientAccountResourcesDetails.PlaceholderResourceType") }
            },
            {
                accessorFn: (originalRow) => {
                    const val = originalRow.IsActive
                    return !!val ? "Active" : "Inactive"
                }, //must be strings
                id: 'isActive',
                header: fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.Status'), //"Status",
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: 
                { placeholder: fetchClientAccResDtlsLabel ("ClientAccountResourcesDetails.PlaceholderStatus") }
            },
        ],
        []
    );

    /** get  "Customized" resources only for processing from addedPDData*/
    const listOfOnlyCustomeTypePDFromAddedPDData = !!addedPDData && addedPDData.filter((eachItem) => {
        if (eachItem?.ProgramDescripitorType === "Customized") {
            return eachItem
        }
    })

    /**setting check box for already selected items */
    useEffect(() => {
        if (!!addedPDData && !!addedPDData?.length) {
            /**{1:true,23:true} to maintain state for selected item*/
            let obj = {}
            addedPDData.forEach((item) => {
                return obj[`${item?.Id}`] = true;
            })
            setRowSelection(obj)
        } else {
            setRowSelection({})
        }
    }, [addedPDData])

    /** */
    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
    }

    //optionally, you can manage the row selection state yourself
    const [rowSelection, setRowSelection] = useState({});

    const handleAddList = () => {
        /**get list of selected objects. These are only of type "Standard". It doesnot have "Customized" one */
        const selectedRowObjList = tableInstanceRef.current
            .getSelectedRowModel()
            .rows.map((eachSelectedRowModel) => {

                const selectedItem = eachSelectedRowModel?.original

                const foundItemFromList = !!addedPDData && !!addedPDData?.length && addedPDData.find((item) => item?.Id === selectedItem?.Id)

                if (!!foundItemFromList) {
                    return foundItemFromList
                } else {
                    return {
                        ...selectedItem,
                        clientAccPDTitle: selectedItem?.ProgramDescripitorTitle || ""
                    }
                }
            });

        if (!!selectedRowObjList && !!selectedRowObjList.length) {
            console.log()
            setAddedPDData([...listOfOnlyCustomeTypePDFromAddedPDData, ...selectedRowObjList])
        } else {
            setAddedPDData(listOfOnlyCustomeTypePDFromAddedPDData)
        }
        handleClose()
    }

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                {/* Select Standard Resources */}
                {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.SelectStandardResourcesTitle')}
                <IconButton
                    sx={{ ml: 'auto' }}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <MaterialReactTable
                    tableInstanceRef={tableInstanceRef}
                    columns={columns}
                    data={listOfOnlyActiveStandardTypeResources || []}
                    // layoutMode="grid"
                    enableGlobalFilter={false}
                    enableDensityToggle={false}
                    initialState={{
                        density: 'compact',
                        showColumnFilters: true
                    }}
                    /**conditionally enable rows with checkbox, rest diable rows */
                    enableRowSelection
                    getRowId={(originalRow) => originalRow.Id}
                    onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                    state={{ rowSelection }}
                    enableStickyHeader
                      muiTablePaginationProps={{
                        labelRowsPerPage: fetchCommonCMSLabel('Common.Rowsperpage') //Rows per page
                      }}
                />

            </DialogContent>
            <DialogActions>
                <Button type='button' onClick={() => {
                    handleAddList()
                }}>{fetchCommonCMSLabel('Common.Add')}</Button>
                <Button onClick={handleClose}>{fetchCommonCMSLabel('Common.Cancel')}</Button>
            </DialogActions>
        </Dialog>
    )
}
export default MpgProgrammeDescriptorDialog